<template>
  <div>
      <page-form ref="formDataName" 
        :formData="formData" 
        @onSubmit="reSearch"
        :needValidation="true"
      />
      <Table ref="moTable" border :columns="columns" :data="tableData" :loading="loading" @on-selection-change="selectionChange" size="small">
          <div slot="header">
              &nbsp;&nbsp;<Button type="primary" :disabled="comfirmIds.length === 0" :loading="comfirmLoading" @click="comfirm">{{ $t('确定') }}</Button>
              <Button type="primary" @click="exportExcel">{{ $t('导出') }}</Button>
              <div style="float:right; display:flex; align-items:center;">
                <Icon type="ios-circle-filled" size="27" color="#DCDCDC" style="margin-right:10px;"></Icon>
                <span style="margin-right:30px;">{{ $t('未确认') }}</span>
                <Icon type="ios-circle-filled" size="27" color="#666666" style="margin-right:10px;"></Icon>
                <span style="margin-right:30px;">{{ $t('已确认') }}</span>
              </div>
          </div>
      </Table>
      <pagination :total="total" :currentPage="current" :pageSize="pageSize" show-sizer @on-current-page-change="handleChange" @on-page-size-change="handlePageChange"></pagination>
  </div>
</template>
<script>
import moment from 'moment';
import pageForm from '@/components/awesome/page/query/index';
import pagination from '@/components/awesome/page/pagination/index';
import axios from 'axios';
export default {
  components: {
    pageForm,
    pagination
  },
  props: {
    itemCode: {
      type: String
    },
    autoSearch: {
      type: Boolean
    }
  },
  data() {
    return {
      comfirmIds: [],
      comfirmLoading: false,
      selection: [],
      orgId: '',
      tableData: [],
      loading: false,
      current: 1,
      pageSize: 10,
      total: 0,
      formData: {
        row: 1,
        items: [
          {
              value: '',
              field: 'itemCode',
              layout: {
                  span: 8,
                  offset: 0,
                  row: 1
              },
              options: {
                  rows: 1
              },
              type: 'text',
              title: this.$t('物料编码')
          },
          {
              value: new Date(moment().subtract(7, 'days').format('YYYY-MM-DD')),
              field: 'checkedDateBegin',
              type: 'datePicker',
              title: this.$t('检验时间'),
              style: 'width: 100%;',
              layout: {
                  row: 1,
                  span: 8,
                  offset: 0
              },
              options: {
                type: 'date',
                format: 'yyyy-MM-dd'
              },
              validators: {
                  required: {
                      required: true,
                      message: this.$t('检验开始日期不能为空')
                  }
              },
              isDouble: true
          },
          {
              hide: true,
              value: new Date(),
              field: 'checkedDateEnd',
              type: 'datePicker',
              title: '',
              style: 'width: 100%;',
              layout: {
                  row: 1,
                  span: 8,
                  offset: 0
              },
              options: {
                type: 'date',
                format: 'yyyy-MM-dd'
              },
              validators: {
                  required: {
                      required: true,
                      message: this.$t('检验结束日期不能为空')
                  }
              }
          },
          {
              value: 'N',
              field: 'confirmFlag',
              disabled: false,
              layout: {
                  span: 8,
                  offset: 0,
                  row: 1
              },
              options: {
                  multiple: false,
                  values: [
                      {
                          label: this.$t('确定'),
                          value: 'Y'
                      },
                      {
                          label: this.$t('未确定'),
                          value: 'N'
                      }
                  ]
              },
              type: 'select',
              title: this.$t('确认状态')
          }
        ]
      },
      columns: [
          {
              type: 'selection',
              width: 60,
              align: 'center'
          },
          {
              title: this.$t('状态'),
              width: 80,
              align: 'center',
              render: (h, params) => {
                  return h('Icon', {
                      props: {
                          type: 'ios-circle-filled',
                          size: 27,
                          color: '#666666'
                      },
                      style: {
                        cursor: params.row.CONFIRM_FLAG === 'Y' ? 'pointer' : 'not-allowed',
                        color: params.row.CONFIRM_FLAG === 'Y' ? '#666666' : '#DCDCDC'
                      },
                      nativeOn: {
                          click: () => {
                              if (params.row.CONFIRM_FLAG === 'Y') {
                                // this.printMo(params.row.makeOrderNum, false);
                              }
                          }
                      }
                  });
              }
          },
          {
              title: this.$t('供应商编码'),
              key: 'SUPPLIER_CODE',
              align: 'center',
              minWidth: 100
          },
          {
              title: this.$t('物料编码'),
              key: 'CODE',
              align: 'center',
              minWidth: 150
          },
          {
              title: this.$t('不合格来源'),
              key: 'BILL_TYPE_DESC',
              align: 'center',
              minWidth: 120
          },
          {
              title: this.$t('检验单号'),
              key: 'EXAMINED_NO',
              align: 'center',
              minWidth: 150
          },
          {
              title: this.$t('检验日期'),
              key: 'CHECKED_DATE_STRING',
              align: 'center',
              minWidth: 200
          },
          {
              title: this.$t('缺陷等级'),
              key: 'NG_LEVEL',
              align: 'center',
              minWidth: 100
          },
          {
              title: this.$t('不及格描述'),
              key: 'PROBLEM_DESC',
              align: 'center',
              minWidth: 300
          }
      ]
    };
  },
  watch: {
    itemCode (newVal) {
      if (newVal) {
        this.formData.items[0].value = newVal;
      }
    },
    autoSearch (newVal) {
      if (newVal) {
        this.reSearch();
      }
    }
  },
  methods: {
    reSearch () {
      let start = this.getFormDataItemVal(this.formData.items, 'checkDateStart');
      let end = this.getFormDataItemVal(this.formData.items, 'checkDateEnd');
      if (moment(end).subtract('6', 'M').format('x') > moment(start).format('x')) {
        this.$Modal.error({
            content: this.$t('日期范围最大不能超过6个月')
        });
        // this.getFormDataItemObj(this.formData.items, 'checkDateStart').value = null;
        // this.getFormDataItemObj(this.formData.items, 'checkDateEnd').value = null;
      } else {
        this.loading = true;
        axios.get('/gscapp/supplier/badResume/QueryIncomingNgList', {
          params: {
            pageIndex: this.current,
            pageSize: this.pageSize,
            orgId: this.orgId,
            itemCode: this.getFormDataItemVal(this.formData.items, 'itemCode'),
            checkedDateBegin: moment(this.getFormDataItemVal(this.formData.items, 'checkedDateBegin')).format('YYYY-MM-DD'),
            checkedDateEnd: moment(this.getFormDataItemVal(this.formData.items, 'checkedDateEnd')).format('YYYY-MM-DD'),
            confirmFlag: this.getFormDataItemVal(this.formData.items, 'confirmFlag'),
            supplierCode: this.vendorCode
          }
        })
        .then((res) => {
          this.loading = false;
          let resp = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
          if (resp.IsSucess) {
            this.tableData = resp.MainResultData.DATA;
            this.total = resp.MainResultData.TOTAL;
          } else {
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$Modal.error({
              title: this.$t('common.warn'),
              content: this.$t('common.error1')
          });
        });
      }
    },
    handleChange (page) {
      this.current = page;
      this.$refs.formDataName.$children[0].$children[0].$children[0].validate((valid) => {
          if (valid) {
            this.reSearch();
          }
      });
    },
    handlePageChange (pageSize) {
      this.pageSize = pageSize;
      this.$refs.formDataName.$children[0].$children[0].$children[0].validate((valid) => {
          if (valid) {
            this.reSearch();
          }
      });
    },
    selectionChange (selection) {
      this.comfirmIds = [];
      this.selection = selection;
      this.selection.map((item) => {
        if (item.CONFIRM_FLAG === 'N') {
          this.comfirmIds.push(item.ID);
        }
      });
    },
    exportExcel () {
      this.$refs.formDataName.$children[0].$children[0].$children[0].validate((valid) => {
          if (valid) {
            if (!this.orgId) {
                this.$Modal.warning({
                    content: '组织信息不能为空，请重新刷新页面',
                });
                return;
            }
            window.open(`/gscapp/supplier/badResume/exportIncomingNgList?orgId=${this.orgId}&itemCode=${this.getFormDataItemVal(this.formData.items, 'itemCode')}&checkedDateBegin=${this.getFormDataItemVal(this.formData.items, 'checkedDateBegin')}&checkedDateEnd=${this.getFormDataItemVal(this.formData.items, 'checkedDateEnd')}&confirmFlag=${this.getFormDataItemVal(this.formData.items, 'confirmFlag')}&supplierCode=${this.vendorCode}`);
          }
      });
    },
    comfirm () {
      this.comfirmLoading = true;
      axios.get('/gscapp/supplier/badResume/ConfirmIncomingNg', {
        params: {
          orgId: this.orgId,
          ids: this.comfirmIds.toString(),
          comfirmUser: this.vendorCode
        }
      })
      .then((res) => {
        this.comfirmLoading = false;
        let resp = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
        if (resp.IsSucess) {
          this.$Modal.success({
              title: '提示',
              content: '确认成功！'
          });
          this.reSearch();
          this.comfirmIds = [];
        } else {
          this.$Modal.error({
              title: this.$t('common.warn'),
              content: this.$t('common.error1')
          });
        }
      })
      .catch(() => {
        this.comfirmLoading = false;
      });
    }
  },
  mounted () {
    this.orgId = this.$route.query.orgId;
  }
};
</script>